/**
 * @module utils/arrayHelpers
 */

export const addOrRemove = (array, value) => {
	const index = array.indexOf(value);
	if (index === -1) {
		array.push(value);
	} else {
		array.splice(index, 1);
	}
};

export const reorder = (array, startIndex, endIndex) => {
	const result = Array.from(array)
	const [removed] = result.splice(startIndex, 1)
	result.splice(endIndex, 0, removed)
	return result
};
